import React, { useState, useRef } from 'react';
import { useSelector } from 'react-redux';
import axios from 'axios';
import ReactLoading from 'react-loading';
import { Box, TextField, Button, Typography } from '@mui/material';

import ConfirmationModal from './ConfirmationModal';
import Modal from '../../../ui/Modal';

const SendMessageModal = ({ bidderName, isOpen, onClose, houseRef, userRef }) => {
  const subjectRef = useRef('');
  const messageRef = useRef('');

  const [subjectError, setSubjectError] = useState('');
  const [messageError, setMessageError] = useState('');
  const [isOpenConfirmationModal, setIsOpenConfirmationModal] = useState(false);
  const [sendMessageLoading, setSendMessageLoading] = useState(false);

  const user = useSelector(state => state.user);

  const { userRef: houseUserRef } = user || {};

  const resetForm = () => {
    subjectRef.current = '';
    messageRef.current = '';
    setSubjectError('');
    setMessageError('');
  };

  const handleCloseModal = () => {
    resetForm();
    onClose();
  };

  const validateSubject = () => {
    const subjectValue = subjectRef.current.value.trim();
    if (!subjectValue) {
      setSubjectError('Subject Required');
      return false;
    }
    setSubjectError('');
    return true;
  };

  const validateMessage = () => {
    const messageValue = messageRef.current.value.trim();
    if (!messageValue) {
      setMessageError('Message Required');
      return false;
    }
    setMessageError('');
    return true;
  };

  const handleSendMessage = async () => {
    const isSubjectValid = validateSubject();
    const isMessageValid = validateMessage();

    if (!isSubjectValid || !isMessageValid) {
      return;
    }

    try {
      setSendMessageLoading(true);
      const { data } = await axios.post(`/app/house/${houseRef}/message`, {
        houseUserRef,
        userRef,
        subject: subjectRef.current.value,
        message: messageRef.current.value,
      });

      if (data.data.success) {
        resetForm();
        onClose();
        setSendMessageLoading(false);
        setIsOpenConfirmationModal(true);
      }
    } catch (error) {
      setSendMessageLoading(false);
      onClose();
    }
  };

  return (
    <>
      <Modal
        isOpen={isOpen}
        toggle={onClose}
      >
        <Modal.Header toggle={onClose}>{`Send message to ${bidderName}`}</Modal.Header>
        <Modal.Body>
          <Box mb={3}>
            <Typography variant="body2" fontWeight="bold" mb={1}>
              Subject:
            </Typography>
            <TextField
              placeholder="Subject"
              id="outlined-textarea"
              variant="standard"
              className="textField"
              inputRef={subjectRef}
              onChange={validateSubject}
            />
            <Typography variant="body2" color="red" mt={1}>
              {subjectError}
            </Typography>
          </Box>
          <Box mb={3}>
            <Typography variant="body2" fontWeight="bold" mb={1}>
              Message:
            </Typography>
            <TextField
              placeholder="Message"
              id="outlined-textarea"
              className="textarea"
              variant="standard"
              multiline
              rows={5}
              inputRef={messageRef}
              onChange={validateMessage}
              InputLabelProps={{
                shrink: true
              }}
            />
            <Typography variant="body2" color="red" mt={1}>
              {messageError}
            </Typography>
          </Box>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="text" color="secondary" className="mr-3" onClick={handleCloseModal}>Cancel</Button>
          <Button
            onClick={handleSendMessage}
            variant="contained"
            color="primary"
            disabled={sendMessageLoading}
          >
            <div style={{ display: 'flex', alignItems: 'center' }}>
              Send Message
              {sendMessageLoading && (
              <ReactLoading className="ml-2" type="spin" height="auto" width={15} />
              )}
            </div>
          </Button>
        </Modal.Footer>
      </Modal>
      <ConfirmationModal
        isOpen={isOpenConfirmationModal}
        onClose={() => setIsOpenConfirmationModal(false)}
        bidderName={bidderName}
      />
    </>
  );
};

export default SendMessageModal;
